import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchSalon from 'actions/fetchSalon.action';
import OverlaySpinner from 'components/generic/OverlaySpinner.component';
import SidebarMenu from 'components/menu/SidebarMenu.component';
import PUSHER from 'config/pusher.singleton';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import logger from 'utils/logger.util';

import { SMS_CREDITS_PUSHER } from 'clientCommunications/constants';
import { getUserPermission } from 'salon/actions';
import PageContent from 'settings/PageContent';

const L = logger('Settings');

class Settings extends React.Component {
  UNSAFE_componentWillMount() {
    const salonId = fromPropsToMatchedSalonId(this.props);
    const currentSalonId = this.props.currentSalon.id;

    L.unignore('UNSAFE_componentWillMount()', 'fetchSalon:', this.props.fetchSalon(salonId));
    this.props.getUserPermission(currentSalonId);
  }

  componentDidMount() {
    this.subscribe();
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { history, fetchSalon } = this.props;

    const newSalonId = fromPropsToMatchedSalonId(nextProps);
    const oldSalonId = fromPropsToMatchedSalonId(this.props);

    if (oldSalonId !== newSalonId) {
      L.unignore('UNSAFE_componentWillReceiveProps()', 'fetchSalon:', fetchSalon(newSalonId));
      history.push(`/salon/${newSalonId}/settings`);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe = () =>
    void PUSHER.redux.subscribe({
      channelName: `${this.props.currentSalon.id}_channel`,
      eventName: 'sms_credits_available',
      actionType: SMS_CREDITS_PUSHER,
    });

  unsubscribe = () =>
    void PUSHER.redux.unsubscribe({
      channelName: `${this.props.currentSalon.id}_channel`,
      eventName: 'sms_credits_available',
      actionType: SMS_CREDITS_PUSHER,
    });

  render() {
    const { betaAnnualSalon, isFetching, currentSalon } = this.props;

    return (
      <div className={`settings ${currentSalon.calendar_mode === 'light' ? 'light-class' : currentSalon.calendar_mode === 'dark' ? 'dark-class' : 'bright-class'}`}>
        {isFetching ? (
          <OverlaySpinner />
        ) : (
          <>
            <SidebarMenu />
            <PageContent betaAnnualSalon={betaAnnualSalon} />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentSalon: state?.currentSalon,
  betaAnnualSalon: state?.currentSalon?.beta_annual_salon,
  isFetching: state?.currentSalon?.isFetching,
  userPermission: state?.salon?.userPermission,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSalon,
      getUserPermission,
    },
    dispatch,
  );

const SettingsHoc = connect(mapStateToProps, mapDispatchToProps)(Settings);

export default SettingsHoc;
